/* AF - Mobile sticky Add to Cart bar.
   Shows once the real Add to Cart has scrolled above the viewport; hides near
   the footer and whenever an overlay is open. Never re-implements add to cart:
   its button clicks the real #ProductSubmitButton-{section}, which is
   re-queried every time because product-info.js can replace the buy box DOM. */
(() => {
  const bar = document.querySelector('[data-af-satc]');
  if (!bar || bar.dataset.afSatcReady) return;
  bar.dataset.afSatcReady = '1';
  // position:fixed is only viewport-relative if no ancestor has a transform
  // (scroll animations, sliders); living directly under <body> guarantees it.
  if (bar.parentElement !== document.body) document.body.appendChild(bar);

  const sid = bar.dataset.sectionId;
  const mq = window.matchMedia('(max-width: 749px)');
  const $ = (sel) => bar.querySelector(sel);
  const atc = $('[data-af-satc-atc]');
  const atcLabel = $('[data-af-satc-atc-label]');
  const sizesBox = $('[data-af-satc-sizes]');
  const priceBox = $('[data-af-satc-price]');
  const errorBox = $('[data-af-satc-error]');

  const realBtn = () => document.getElementById(`ProductSubmitButton-${sid}`);
  const picker = () => document.querySelector(`#MainProduct-${sid} variant-selects`);
  const priceEl = () => document.querySelector(`#price-${sid} .price`);
  const errorWrap = () =>
    document.querySelector(`#MainProduct-${sid} .product-form__error-message-wrapper`);

  let btnAbove = false;   // real ATC scrolled above the viewport
  let footerIn = false;   // footer is on screen
  let errorTimer = 0;

  const OVERLAYS = [
    'cart-drawer.active',
    '.drawer.active',
    '#af-overlay-menu-root.is-open',
    '#af-overlay-facets-root.is-open',
    '.af-newsletter-overlay.is-visible',
    'dialog.af-sheet[open]', // trust sheets, size guide (assets/af-sheet.js)
    '.product-media-modal[open]',
  ].join(',');
  const overlayOpen = () => !!document.querySelector(OVERLAYS);

  const isUnavailable = (b) =>
    !b || b.disabled || b.getAttribute('aria-disabled') === 'true' ||
    b.hasAttribute('disabled');

  /* ---------- mirror real buy box ---------- */
  // One chip per value of the (single) size option: "15ML Decant (225+ sprays)"
  // -> "15" + "ML". Multi-option products get no chips (they'd be ambiguous).
  const chipParts = (v) => {
    const head = v.split('(')[0].trim().split(' ')[0] || v;
    const m = head.match(/^([\d.]+)\s*(ml)$/i);
    return m ? [m[1], m[2].toUpperCase()] : [head, ''];
  };
  const sizeInputs = () => {
    const p = picker();
    if (!p || p.querySelectorAll('fieldset, select').length !== 1) return null;
    const sel = p.querySelector('select');
    if (sel) return [...sel.options].map((o) => ({ value: o.value, checked: o.selected, off: o.disabled || o.classList.contains('disabled') || /unavailable|sold out/i.test(o.textContent.replace(o.value, '')) }));
    return [...p.querySelectorAll('input[type="radio"]')].map((i) => ({ value: i.value, checked: i.checked, off: i.classList.contains('disabled') }));
  };
  let anyAvailable = false;
  function syncSizes() {
    if (!sizesBox) return;
    const list = sizeInputs();
    sizesBox.hidden = !list || list.length < 2;
    anyAvailable = !!list && list.some((o) => !o.off);
    if (sizesBox.hidden) return;
    const key = list.map((o) => o.value).join('|');
    if (sizesBox.dataset.key !== key) {
      sizesBox.dataset.key = key;
      sizesBox.textContent = '';
      list.forEach((o) => {
        const c = document.createElement('button');
        c.type = 'button';
        c.className = 'af-satc__chip';
        c.dataset.value = o.value;
        const [num, unit] = chipParts(o.value);
        const n = document.createElement('span');
        n.className = 'af-satc__chip-n';
        n.textContent = num;
        c.appendChild(n);
        if (unit) {
          const u = document.createElement('span');
          u.className = 'af-satc__chip-u';
          u.textContent = unit;
          c.appendChild(u);
        }
        c.setAttribute('aria-label', o.value);
        sizesBox.appendChild(c);
      });
    }
    list.forEach((o, i) => {
      const c = sizesBox.children[i];
      c.setAttribute('aria-pressed', o.checked ? 'true' : 'false');
      c.classList.toggle('is-off', o.off);
    });
  }

  // No scroll "hold" here: product-info.js now focuses the picked input with
  // preventScroll, so a swap no longer jumps the page. Restoring the old
  // scrollY also undid the browser's own anchoring whenever the buy box above
  // changed height, so the content jumped and the header slid in or out.

  // True from a size change until product-info.js publishes the new variant.
  let switching = false;
  let switchTimer = 0;
  function startSwitch() {
    switching = true;
    clearTimeout(switchTimer);
    switchTimer = setTimeout(() => { switching = false; syncAll(); }, 4000);
  }
  function endSwitch() {
    switching = false;
    clearTimeout(switchTimer);
  }

  // Select through the real picker so product-info.js does the variant swap.
  function choose(value) {
    const p = picker();
    if (!p) return;
    const sel = p.querySelector('select');
    if (sel) {
      if (sel.value === value) return;
      startSwitch();
      sel.value = value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    const input = [...p.querySelectorAll('input[type="radio"]')].find((i) => i.value === value);
    if (!input || input.checked) return;
    startSwitch();
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function syncPrice() {
    const pr = priceEl();
    const now = pr && (pr.classList.contains('price--on-sale')
      ? pr.querySelector('.price__sale .price-item--last')
      : pr.querySelector('.price__regular .price-item--regular'));
    const was = pr && pr.classList.contains('price--on-sale')
      ? pr.querySelector('.price__sale s.price-item--regular') : null;
    // data-af-price: clean text while af-price-odometer.js spins the main price
    const clean = (el) => (el ? (el.dataset.afPrice || el.textContent).trim() : '');
    const txt = clean(now);
    const wasTxt = clean(was);
    const key = txt + '|' + wasTxt;
    if (priceBox.dataset.key === key) return; // unchanged: leave it (and any animation) alone
    const prevAmount = ((priceBox.dataset.key || '').split('|')[0].match(/[\d][\d.,]*/) || [''])[0];
    priceBox.dataset.key = key;
    priceBox.textContent = '';
    if (!now) return;
    // "৳ 363": the amount is what gets centred; the symbol hangs to its left
    const m = txt.match(/^([^\d]*?)\s*([\d][\d.,]*)\s*(.*)$/);
    const amt = document.createElement('span');
    amt.className = 'af-satc__tag-now';
    if (m) {
      if (m[1]) {
        const cur = document.createElement('span');
        cur.className = 'af-satc__tag-cur';
        cur.setAttribute('aria-hidden', 'true');
        cur.textContent = m[1];
        amt.appendChild(cur);
      }
      priceBox.appendChild(amt); // attached first: the odometer measures the font
      if (window.AFOdometer) window.AFOdometer.render(amt, m[2], prevAmount);
      else amt.appendChild(document.createTextNode(m[2]));
      if (m[3]) amt.appendChild(document.createTextNode(' ' + m[3]));
      const sr = document.createElement('span');
      sr.className = 'visually-hidden';
      sr.textContent = txt;
      amt.appendChild(sr);
    } else {
      amt.textContent = txt;
      priceBox.appendChild(amt);
    }
    if (wasTxt) {
      const w = document.createElement('s');
      w.className = 'af-satc__tag-was';
      w.textContent = wasTxt;
      priceBox.appendChild(w);
    }
  }

  function syncButton() {
    const b = realBtn();
    const unavailable = isUnavailable(b);
    const loading = !!b && b.classList.contains('loading');
    const label = b && b.querySelector('span:not(.visually-hidden)');
    atcLabel.textContent = label ? label.textContent.trim() : atcLabel.textContent;
    // While a size switch is fetching, the theme disables the real button for
    // a moment; that is not "unavailable", so the price tab stays put.
    if (!switching) priceBox.hidden = unavailable;
    atc.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
    atc.classList.toggle('is-loading', loading);
    atc.classList.toggle('is-soldout', unavailable && !loading && !switching);
  }

  function syncAll() { syncSizes(); syncPrice(); syncButton(); update(); }

  /* ---------- visibility ---------- */
  function update() {
    const b = realBtn();
    // A sold-out size stays visible (another chip can be picked); a fully
    // sold-out product has nothing to offer, so the bar stays hidden.
    const soldOutAll = !!b && isUnavailable(b) && !b.classList.contains('loading') && !anyAvailable;
    const show = mq.matches && !!b && btnAbove && !footerIn && !overlayOpen() && !soldOutAll;
    bar.classList.toggle('is-on', show);
    bar.toggleAttribute('inert', !show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    document.body.classList.toggle('af-satc-on', show);
  }

  // The buy box (sometimes the whole section) is re-rendered after load, so
  // the button is looked up fresh each frame instead of observed once.
  let observedBtn = null;
  function watchButton() {
    const b = realBtn();
    if (b === observedBtn) return;
    observedBtn = b;
    watchButtonState(b);
    watchErrors();
    syncAll();
  }
  let rafScroll = 0;
  function onScroll() {
    if (rafScroll) return;
    rafScroll = requestAnimationFrame(() => {
      rafScroll = 0;
      watchButton();
      const b = realBtn();
      const above = !!b && b.getBoundingClientRect().bottom < 0;
      if (above !== btnAbove) { btnAbove = above; update(); }
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  const btnMO = new MutationObserver(() => { syncButton(); update(); });
  function watchButtonState(b) {
    btnMO.disconnect();
    if (b) btnMO.observe(b, { attributes: true, attributeFilter: ['class', 'disabled', 'aria-disabled'], childList: true, subtree: true, characterData: true });
  }

  const footer = document.querySelector('footer, .footer, #shopify-section-footer, [id*="footer-group"]');
  if (footer) {
    new IntersectionObserver((entries) => {
      footerIn = entries[entries.length - 1].isIntersecting;
      update();
    }).observe(footer);
  }

  // Overlays open/close by toggling classes/attributes anywhere in the body.
  let raf = 0;
  new MutationObserver(() => {
    if (raf) return;
    raf = requestAnimationFrame(() => { raf = 0; update(); });
  }).observe(document.body, { attributes: true, attributeFilter: ['class', 'open'], subtree: true });

  /* ---------- errors from the real form ---------- */
  let observedErr = null;
  const errMO = new MutationObserver(() => {
    const w = observedErr;
    const msg = w && w.querySelector('.product-form__error-message');
    const text = w && !w.hasAttribute('hidden') && msg ? msg.textContent.trim() : '';
    if (!text || !bar.classList.contains('is-on')) return;
    errorBox.textContent = text;
    errorBox.hidden = false;
    clearTimeout(errorTimer);
    errorTimer = setTimeout(() => { errorBox.hidden = true; }, 5000);
  });
  function watchErrors() {
    const w = errorWrap();
    if (w === observedErr) return;
    errMO.disconnect();
    observedErr = w;
    if (w) errMO.observe(w, { attributes: true, childList: true, subtree: true, characterData: true });
  }

  /* ---------- actions ---------- */
  atc.addEventListener('click', () => {
    const b = realBtn();
    if (isUnavailable(b) || b.classList.contains('loading')) return;
    errorBox.hidden = true;
    b.click();
  });

  if (sizesBox) {
    sizesBox.addEventListener('click', (e) => {
      const c = e.target.closest('.af-satc__chip');
      if (c) choose(c.dataset.value);
    });
  }

  /* ---------- variant changes ---------- */
  const onVariant = () => requestAnimationFrame(() => {
    watchButton();
    syncAll();
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => { endSwitch(); onVariant(); });
  }
  document.addEventListener('change', (e) => {
    if (!(e.target && e.target.closest && e.target.closest(`#MainProduct-${sid} variant-selects`))) return;
    startSwitch();
    onVariant(); // chip highlight moves at once; price follows when the fetch lands
  });

  mq.addEventListener ? mq.addEventListener('change', update) : mq.addListener(update);
  window.addEventListener('pageshow', () => { watchButton(); syncAll(); });

  watchButton();
  watchErrors();
  syncAll();
  onScroll(); // restored scroll position on reload / back
})();
